import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "kacis",
  name: "Kaçış",
  tagline: "Jöle solucanları aynı renkli kapıdan kaçır; harfler doğru sırayla çıkarsa gizli kelimeyi bulursun.",
  inspiredBy: "Jelly Escape (Circle Games) / snake-out bulmacaları",
  secondLayer: "Kelime: her solucan oyuncunun dilinde (TR/EN) bir harf taşır; kaçış sırası gizli kelimeyi yazar (ipucu: karışık harfler), doğru sıra ★ Kelime kazandırır",
  accent: "#2ec4b6",
  status: "lab",
};
